import React, { useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import getClassroomStore from 'graph/state/query-hooks/use-get-classroom';
import Divider from '@mui/material/Divider';
import AssessmentsTabulatedMenu from './components/AssessmentsTabulatedMenu';
import CurriculumSelector from 'components/common/CurriculumSelector';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { parseQueryParams } from '@lwtears/lwt-common-frontend/lib/@common/util/query-params-util';
import { AssessmentContext } from 'state/providers/AssessmentProvider';
import { AssessmentTabs } from 'types';

const Class = (): React.ReactElement => {
  const navigate = useNavigate();
  const { id } = useParams();
  const classes = useStyles();
  const { curriculumId } = useContext(AssessmentContext);

  const classroomId = typeof id === 'undefined' ? 1 : parseInt(id!);
  const query = parseQueryParams();
  const tabSelection = query?.tabSelection ? query.tabSelection : AssessmentTabs.BENCHMARK;
  const [classroom] = getClassroomStore(classroomId);

  if (classroom.isLoading || !classroom.data) return <></>;
  if (Object.keys(classroom.data).length === 0) navigate('/404');

  const students = classroom.data.students ?? [];

  return (
    <div className={classes.mainContainer} style={{ flexGrow: 1 }}>
      <Grid container item xs={12} className={classes.pageHeader}>
        <Grid item xs={9}>
          <Typography variant="h1">{classroom.data.name}</Typography>
        </Grid>
        <CurriculumSelector />
      </Grid>
      <Divider />
      {curriculumId && (
        <AssessmentsTabulatedMenu
          students={students}
          classId={classroomId}
          curriculumId={curriculumId}
          key={curriculumId}
          tabSelection={tabSelection}
        />
      )}
    </div>
  );
};

export default Class;

const useStyles = makeStyles((theme: Theme) => {
  return {
    mainContainer: {
      paddingLeft: theme.spacing(30),
      paddingRight: theme.spacing(30),
      paddingBottom: theme.spacing(10),
    },
    pageHeader: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(2),
      alignItems: 'flex-end',
    },
  };
});
